import {Component, OnInit} from '@angular/core';
import {PromotionLayoutModel} from '../../../models/promotion-layout.model';
import {PromotionLayoutService} from '../../../services/promotion/promotion-layout.service';
import {LoyaltyParamsService} from '../../../services/loyalty/params.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'kv-promo-layout',
  template: `
    <app-kontable
      title="{{ 'layout.layout' | translate }}"
      [columns]="['id', 'code', 'description']"
      [titles]="['#', 'promotion.code', 'promotion.description']"
      [source]="layouts"
      [showInfoButton]="true"
      [showRecoverButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      [showGlobalFilter]="false"
      (onAdd)="showAdd()"
      (onEdit)="showEdit($event)"
      (onRemove)="delete($event)"
      *ngIf="!show">
    </app-kontable>
    <kv-promo-layout-detail
      *ngIf="show"
      [titlePage]="titlePage"
      [layout]="addEditLayout"
      (hide)="toggleShow()"
      (saveLayout)="saveLayout($event)"
      [printTypes]="layoutPrintTypes"
      [tillTypes]="layoutTillTypes"
      [templates]="layoutTemplates"
      [layoutDetailRowPositions]="layoutDetailRowPositions">
    </kv-promo-layout-detail>
  `
})
export class LayoutComponent implements  OnInit{
  addEditLayout: any;
  titlePage = '';
  show = false;
  layouts: PromotionLayoutModel[];
  layoutPrintTypes = [];
  layoutTillTypes = [];
  layoutTemplates = [];
  layoutDetailRowPositions = [];
  choosePrintType;
  chooseTillType;
  chooseTemplate;
  chooseDetailRowPosition;

  constructor(private svcLayout: PromotionLayoutService,
              private svcParams: LoyaltyParamsService,
              private srvTranslate: TranslateService) {

    this.srvTranslate.get(['promotion.selectPrintTypePid']).subscribe((res) => {
      this.choosePrintType = res['promotion.selectPrintTypePid']
    });

    this.srvTranslate.get(['promotion.selectTillTypePid']).subscribe((res) => {
      this.chooseTillType = res['promotion.selectTillTypePid']
    });

    this.srvTranslate.get(['promotion.selectTemplate']).subscribe((res) => {
      this.chooseTemplate = res['promotion.selectTemplate']
    });

    this.srvTranslate.get(['promotion.detailRowPosition']).subscribe((res) => {
      this.chooseTemplate = res['promotion.detailRowPosition']
    });

    this.srvTranslate.get(['promotion.chooseDetailRowPosition']).subscribe((res) => {
      this.chooseDetailRowPosition = res['promotion.chooseDetailRowPosition']
    });

    this.reloadList();

    this.svcParams.list(0, 999999, [
        {
          key: 'param_group',
          value: 'LayoutPrintType'
        }
      ]
    ).subscribe(p => {
      this.layoutPrintTypes = [{label: this.choosePrintType, value: null}];
      for (let elem of p.data) {
        this.layoutPrintTypes.push({
          label: elem.description,
          value: elem.id
        })
      }
    });

    this.svcParams.list(0, 999999, [
        {
          key: 'param_group',
          value: 'LayoutTillType'
        }
      ]
    ).subscribe(p => {
      this.layoutTillTypes = [{label: this.chooseTillType, value: null}];
      for (let elem of p.data) {
        this.layoutTillTypes.push({
          label: elem.description,
          value: elem.id
        })
      }
    });

    this.svcParams.list(0, 999999, [
        {
          key: 'param_group',
          value: 'LayoutTemplate'
        }
      ]
    ).subscribe(p => {
      this.layoutTemplates = [{label: this.chooseTemplate, value: null}];
      for (let elem of p.data) {
        this.layoutTemplates.push({
          label: elem.description,
          value: elem.id
        })
      }
    });

    this.svcParams.list(0, 999999, [
        {
          key: 'param_group',
          value: 'LayoutDetailRowPosition'
        }
      ]
    ).subscribe(p => {
      this.layoutDetailRowPositions = [{label: this.chooseDetailRowPosition, value: null}];
      for (let elem of p.data) {
        this.layoutDetailRowPositions.push({
          label: elem.description,
          value: elem.id
        })
      }
    });
  }

  ngOnInit(): void {}

  reloadList() {
    this.layouts = [];
    this.svcLayout.list(0, 999999).subscribe( res => {
      this.layouts = res.data;
    });
  }

  saveLayout(item: any) {
    if (!item.id) {
      /*Creazione nuovo layout SENZA id*/
      this.svcLayout.create({
        code: item.code,
        description: item.description,
        flg_graph: item.flg_graph,
        bmp_path: item.bmp_path,
        bmp_ref: item.bmp_ref,
        layout_barcode: item.layout_barcode,
        layout_print_type_pid: item.layout_print_type_pid,
        layout_till_type_pid: item.layout_till_type_pid,
        layout_template_pid: item.layout_template_pid,
        details: !item.details || item.details.length === 0 ? [] : item.details
      }).subscribe(() => {
        this.titlePage = '';
        this.addEditLayout = null;
        this.toggleShow();
        this.reloadList();
      });
    }else {
      /*Modifica layout esistente CON id */
      this.svcLayout.update({
        id: item.id,
        code: item.code,
        description: item.description,
        flg_graph: item.flg_graph,
        bmp_path: item.bmp_path,
        bmp_ref: item.bmp_ref,
        layout_barcode: item.layout_barcode,
        layout_print_type_pid: item.layout_print_type_pid,
        layout_till_type_pid: item.layout_till_type_pid,
        layout_template_pid: item.layout_template_pid,
        details: !item.details || item.details.length === 0 ? [] : item.details
      }).subscribe(() => {
        this.titlePage = '';
        this.addEditLayout = null;
        this.toggleShow();
        this.reloadList();
      });
    }
  }

  toggleShow() {
    this.show = !this.show
  }

  delete(item) {
    this.svcLayout.delete(item.id).subscribe(() => {
      this.reloadList();
    });
  }

  showEdit(item) {
    this.titlePage = 'promotion.editLayout';
    this.svcLayout.get(item.id).subscribe((res) => {
      this.addEditLayout = res;
      this.toggleShow();
    })
  }

  showAdd() {
    this.titlePage = 'promotion.addLayout';
    this.addEditLayout = {
      code: null,
      description: null,
      flg_graph: false,
      bmp_path: null,
      bmp_ref: null,
      layout_barcode: null,
      layout_print_type_pid: null,
      layout_till_type_pid: null,
      layout_template_pid: null,
      details: []

    };
    this.toggleShow();
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/layout/layout.component.ts